<div [class.hasTopClearance]="(isGlobalBannerEnabled$ | async)"  class="bp-modal-container" [class.fade-in]="modal?.isShowing" [class.fade-out]="!modal?.isShowing" aria-labelledby="modal-title" aria-modal="true">
	<div #modalContainer></div>
</div>
